import { createFileRoute } from "@tanstack/react-router";
import { WaitingBackend } from "@/components/waiting-backend";

export const Route = createFileRoute("/drivers")({
  component: () => (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Motoristas</h1>
        <p className="text-sm text-muted-foreground">Cadastro, jornada e desempenho dos condutores.</p>
      </div>
      <WaitingBackend />
    </div>
  ),
  head: () => ({ meta: [{ title: "Motoristas — Wp Rastreamento" }] }),
});
